import { render, staticRenderFns } from "./uploadpic.vue?vue&type=template&id=13094187&"
import script from "./uploadpic.vue?vue&type=script&lang=js&"
export * from "./uploadpic.vue?vue&type=script&lang=js&"
import style0 from "./uploadpic.vue?vue&type=style&index=0&id=13094187&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports